<button
    [hidden]="ttDisabled === 'hidden'"
    class="tt-grid__toolbar-button--custom"
    [ngClass]="buttonClasses"
    (click)="onClick($event)"
    [disabled]="ttDisabled"
    [style.fontSize]="'calc(var(--ag-font-size) - 2px)'"
>
    <span class="fa-fw" [ngClass]="icon" style="font-size: 1.6rem"></span>
    <span *ngIf="!!text" [style.fontSize]="'var(----ag-grid-fontSize)'">{{ text }}</span>
</button>
